var map = {
	"./BN.jpg": 2575,
	"./ID.jpg": 7316,
	"./KH.jpg": 530,
	"./LA.jpg": 702,
	"./MM.jpg": 5229,
	"./MY.jpg": 4801,
	"./PH.jpg": 47,
	"./SG.jpg": 3793,
	"./TH.jpg": 2459,
	"./TL.jpg": 5703,
	"./VN.jpg": 2595,
	"./blue.jpg": 1835,
	"./red.jpg": 1270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2116;